import React, { Fragment, useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { BootstrapToolTip } from '@/_elements/ToolTip';
import { BsPencil } from 'react-icons/bs';
import { RECEIPT_CATEGORY_TYPES, RECEIPT_PAYMENT_TYPES } from '@/contants/form';
import Select from 'react-select';
import DateTimePicker from 'react-datetime-picker/dist/DateTimePicker';
import { updateExpense } from '@/_services/api/expense';
import { VscLoading } from 'react-icons/vsc';

const ExpenseEditModal = ({ expense, handleUpdateExpense }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);

    const [formData, setFormData] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        try {
            setIsBusy(true);
            const response = await updateExpense({
                expenseId: expense._id,
                data: formData,
            });
            handleUpdateExpense(response);
            toast.success('Expense updated successfully');
            handleClose();
        } catch (error) {
            toast.error(error.message || 'Failed to update expense');
        } finally {
            setIsBusy(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            setFormData({
                amount: expense.amount || '',
                vendor: expense.vendor || '',
                paymentMethod: expense.paymentMethod || '',
                category: expense.category || '',
                receiptDate: expense.receiptDate || null,
            });
        }
    }, [isOpen]);

    return (
        <Fragment>
            <BootstrapToolTip text="Edit">
                <BsPencil className="icon edit" onClick={handleOpen} />
            </BootstrapToolTip>
            <Modal show={isOpen} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Expense</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label className="form-label">Amount</Form.Label>
                        <Form.Control
                            type="number"
                            name="amount"
                            value={formData.amount}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label className="form-label">Vendor</Form.Label>
                        <Form.Control
                            type="text"
                            name="vendor"
                            value={formData.vendor}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label className="form-label">Receipt Category Type</Form.Label>
                        <Select
                            name="category"
                            value={RECEIPT_CATEGORY_TYPES.map((type) => ({
                                label: type.text,
                                value: type.text,
                            })).find((option) => option.value === formData.category)}
                            onChange={(selectedOption) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    category: selectedOption ? selectedOption.value : '',
                                }))
                            }
                            options={RECEIPT_CATEGORY_TYPES.filter((x) => x.text).map((type) => ({
                                label: type.text,
                                value: type.text,
                            }))}
                            isClearable
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label className="form-label">Payment Type</Form.Label>
                        <Select
                            name="paymentMethod"
                            value={RECEIPT_PAYMENT_TYPES.map((type) => ({
                                label: type.text,
                                value: type.text,
                            })).find((option) => option.value === formData.paymentMethod)}
                            onChange={(selectedOption) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    paymentMethod: selectedOption ? selectedOption.value : '',
                                }))
                            }
                            options={RECEIPT_PAYMENT_TYPES.filter((x) => x.text).map((type) => ({
                                label: type.text,
                                value: type.text,
                            }))}
                            isClearable
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label className="form-label">Receipt Date</Form.Label>
                        <DateTimePicker
                            onChange={(date) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    receiptDate: date ? date : null,
                                }))
                            }
                            maxDate={new Date()}
                            defaultValue={formData.receiptDate ? new Date(formData.receiptDate) : null}
                            value={formData.receiptDate ? new Date(formData.receiptDate) : null}
                            format="MM-dd-y hh:mm a"
                            disableClock={true}
                            calendarType={'US'}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSubmit} disabled={isBusy}>
                        {isBusy && <VscLoading className="spin mr-2" />}
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default ExpenseEditModal;
